export default "__VITE_ASSET__BgT1iPHD__"